// ─────────────────────────────────────────────────────────────────────────────
//  ANKÜNDIGUNGS-POPUP – KONFIGURATION
//
//  Hier wird das Popup auf der Startseite gepflegt. Es muss NUR diese Datei
//  bearbeitet werden – die Komponente selbst bleibt unverändert.
//
//  Schnellanleitung:
//   1. `enabled` auf true setzen, um das Popup zu aktivieren (false = aus).
//   2. Bei einer NEUEN Ankündigung die `id` ändern (z.B. "sommerfest-2026" →
//      "weihnachtsfeier-2026"). Dadurch sehen auch Besucher, die das alte
//      Popup geschlossen hatten, die neue Ankündigung wieder.
//   3. Bild in `static/img/` ablegen und unter `image` den Pfad eintragen
//      (z.B. "/img/mein-bild.png"). Ohne Bild wird das Popup einspaltig.
//   4. Texte unten anpassen. In `body` und `contact` sind einfache HTML-Tags
//      erlaubt (z.B. <strong>, <a href="...">).
// ─────────────────────────────────────────────────────────────────────────────

export interface Announcement {
  /** true = Popup wird angezeigt, false = komplett aus. */
  enabled: boolean;
  /** Eindeutige ID der Ankündigung. Bei neuer Ankündigung ändern, damit das
   *  Popup auch bei zuvor schließenden Besuchern erneut erscheint. */
  id: string;
  /** Verzögerung in ms, bevor das Popup erscheint (Standard 2000). */
  showDelayMs?: number;

  /** Bildpfad relativ zu /static (optional), z.B. "/img/einladung.png". */
  image?: string;
  imageAlt?: string;
  /** Kleiner Text über dem Bild, z.B. "Einladung". */
  leftTag?: string;
  /** Titel über dem Bild – jede Zeile ein Array-Eintrag. */
  leftTitle?: string[];

  /** Datums-Badge (optional). */
  date?: {
    /** Kurzmonat im Icon, z.B. "Jun". */
    month: string;
    /** Tag im Icon, z.B. "13". */
    day: string;
    /** Ausgeschriebenes Datum, z.B. "13. Juni 2026". */
    full: string;
    /** Zusatz, z.B. Uhrzeit "10:00 – 16:00 Uhr". */
    sub?: string;
  };

  /** Fließtext-Absätze. Einfaches HTML erlaubt (<strong> etc.). */
  body: string[];
  /** Schlagwort-Chips (optional). */
  highlights?: string[];

  /** Adressblock (optional). */
  address?: {
    /** Überschrift, Standard "Ort". */
    label?: string;
    /** Adresszeilen. */
    lines: string[];
  };

  /** Fußzeile/Kontakt (optional). Einfaches HTML erlaubt (<a href> etc.). */
  contact?: string[];

  /** Reaktivierungs-Banner, das nach dem Schließen oben erscheint. */
  banner?: {
    date?: string;
    text: string;
  };
}

export const announcement: Announcement = {
  // Auf true setzen, um das Popup live zu schalten.
  enabled: false,
  id: "sommerfest-2026",
  showDelayMs: 2000,

  image: "/img/Showroom_Aquarell_Transparent.png",
  imageAlt: "Heinze Pool Showroom Illustration",
  leftTag: "Einladung",
  leftTitle: ["Showroom-", "Sommerfest"],

  date: {
    month: "Jun",
    day: "13",
    full: "13. Juni 2026",
    sub: "10:00 – 16:00 Uhr",
  },

  body: [
    "Wir laden Sie herzlich zur Eröffnung unseres neuen Showrooms ein – und " +
      "möchten diesen besonderen Anlass gemeinsam mit Ihnen bei einem " +
      "<strong>Sommerfest</strong> feiern.",
    "Lernen Sie unsere Poolwelt in entspannter Atmosphäre kennen und lassen " +
      "Sie sich von neuen Ideen begeistern.",
  ],

  highlights: [
    "Einblicke & Beratung",
    "Verpflegung",
    "Kinderprogramm",
    "Exklusive Angebote",
  ],

  address: {
    label: "Ort",
    lines: ["Siemensstraße 3", "30916 Isernhagen"],
  },

  contact: [
    "Ihr Heinze Pool Team",
    '<a href="tel:+4951127131450">(+49) 511 2713145</a>' +
      "&nbsp;&nbsp;·&nbsp;&nbsp;" +
      '<a href="mailto:info@heinze-pool.de">info@heinze-pool.de</a>',
  ],

  banner: {
    date: "13. Juni",
    text: "Showroom-Sommerfest – Jetzt entdecken",
  },
};
